export default class {
    addEventListener(eventName, callback) {
      if (!(eventName in this.events)) {
        this.events[eventName] = [];
      }
      this.events[eventName].push(callback);
    }

    fireEvent(eventName, data) {
      if (Array.isArray(this.events[eventName])) {
        const events = this.events[eventName].concat([]);
        events.forEach(evt => evt(data));
      }
    }
    destroy() {
        for (const event in this.events) {
            delete this.events[event];
        }
    }
}


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/mixins/observable.js